type Point2D = { x: number; y: number };

/**
 * @description Orthogonal projection of a point onto a line segment, in 2D.
 * Returns the closest point on the segment to the given point (never extends beyond start/end).
 *
 *     point *
 *           |  <- perpendicular
 *           v
 *  start *--*-----------* end
 *        projected
 */
function projectPointOntoSegment2D({ point, start, end }: { point: Point2D; start: Point2D; end: Point2D }): Point2D {
	const dx = end.x - start.x;
	const dy = end.y - start.y;
	const lengthSq = dx * dx + dy * dy;

	if (lengthSq === 0) {
		return { x: start.x, y: start.y };
	}

	const tValue = ((point.x - start.x) * dx + (point.y - start.y) * dy) / lengthSq;
	const t = Math.max(0, Math.min(1, tValue));

	return { x: start.x + t * dx, y: start.y + t * dy };
}

export { type Point2D, projectPointOntoSegment2D };
